import { addDays, isoDate } from './hooks';

/** Start and end Date objects for a named period, or [null, null] for "All time". */
export function rangeOf(name) {
  const today = new Date();
  const monday = addDays(today, -((today.getDay() + 6) % 7));
  const y = today.getFullYear();
  const m = today.getMonth();
  const quarterStart = Math.floor(m / 3) * 3;
  switch (name) {
    case 'Today': return [today, today];
    case 'Last 7 Days': return [addDays(today, -6), today];
    case 'Last 30 Days': return [addDays(today, -29), today];
    case 'Last Week': return [addDays(monday, -7), addDays(monday, -1)];
    case 'Current Week': return [monday, addDays(monday, 6)];
    case 'Last Month': return [new Date(y, m - 1, 1), new Date(y, m, 0)];
    case 'Current Month': return [new Date(y, m, 1), new Date(y, m + 1, 0)];
    case 'Last Quarter': return [new Date(y, quarterStart - 3, 1), new Date(y, quarterStart, 0)];
    case 'Current Quarter': return [new Date(y, quarterStart, 1), new Date(y, quarterStart + 3, 0)];
    case 'Last Year': return [new Date(y - 1, 0, 1), new Date(y - 1, 11, 31)];
    case 'Current Year': return [new Date(y, 0, 1), new Date(y, 11, 31)];
    default: return [null, null];
  }
}

export const rangeIso = (name) => rangeOf(name).map((d) => (d ? isoDate(d) : ''));
